import UserActions from "#SRC/js/constants/UserActions";

const PodActionItem = {
  EDIT: "edit",
  DELETE: UserActions.DELETE,
  SCALE: "scale",
  SUSPEND: "suspend"
};

module.exports = PodActionItem;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/PodActionItem.js